import React from 'react';

import {
  HandlesContext,
  HandlesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/HandlesContext';
import {
  NodesContext,
  NodesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/NodesContext';
import {
  PlatformFeaturesContext,
  PlatformFlowchartFeatures,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/PlatformFeaturesContext';

import {CustomMappingContext, CustomMappingContextValue} from './CustomMappingContext';

export interface CanvasContextProvidersProps {
  platformFeaturesContext: PlatformFlowchartFeatures;
  handlesContext: HandlesContextValue;
  nodesContext: NodesContextValue;
  customMappingContext: CustomMappingContextValue;
  children: React.ReactNode;
}

/**
 * Wraps the canvas in context providers needed for rendering the flowchart.
 */
export function CanvasContextProviders({
  platformFeaturesContext,
  handlesContext,
  nodesContext,
  customMappingContext,
  children,
}: CanvasContextProvidersProps): JSX.Element {
  return (
    <PlatformFeaturesContext.Provider value={platformFeaturesContext}>
      <HandlesContext.Provider value={handlesContext}>
        <NodesContext.Provider value={nodesContext}>
          <CustomMappingContext.Provider value={customMappingContext}>
            {children}
          </CustomMappingContext.Provider>
        </NodesContext.Provider>
      </HandlesContext.Provider>
    </PlatformFeaturesContext.Provider>
  );
}
